module.exports = __webpack_public_path__ + "img/flag-eua.6aaa6b9c.png";